module.exports = __webpack_public_path__ + "img/rightbicep-endomorph-female.2246c63a.svg";